export default [
    {
        lat: 48.625,
        lng: 11.67,
    },
    {
        lat: 48.645,
        lng: 11.675,
    },
    {
        lat: 48.655,
        lng: 11.665,
    },
    {
        lat: 48.67,
        lng: 11.665,
    },
    {
        lat: 48.69,
        lng: 11.635,
    },
    {
        lat: 48.72,
        lng: 11.64,
    },
    {
        lat: 48.75,
        lng: 11.635,
    },
    {
        lat: 48.77,
        lng: 11.66,
    },
    {
        lat: 48.77,
        lng: 11.675,
    },
    {
        lat: 48.795,
        lng: 11.675,
    },
    {
        lat: 48.805,
        lng: 11.69,
    },
    {
        lat: 48.82,
        lng: 11.68,
    },
    {
        lat: 48.825,
        lng: 11.685,
    },
    {
        lat: 48.845,
        lng: 11.68,
    },
    {
        lat: 48.865,
        lng: 11.7,
    },
    {
        lat: 48.885,
        lng: 11.705,
    },
    {
        lat: 48.905,
        lng: 11.69,
    },
    {
        lat: 48.91,
        lng: 11.635,
    },
    {
        lat: 48.94,
        lng: 11.58,
    },
    {
        lat: 48.965,
        lng: 11.575,
    },
    {
        lat: 48.98,
        lng: 11.59,
    },
    {
        lat: 49.02,
        lng: 11.595,
    },
    {
        lat: 49.03,
        lng: 11.61,
    },
    {
        lat: 49.025,
        lng: 11.64,
    },
    {
        lat: 49.035,
        lng: 11.65,
    },
    {
        lat: 49.04,
        lng: 11.705,
    },
    {
        lat: 49.03,
        lng: 11.735,
    },
    {
        lat: 49.01,
        lng: 11.755,
    },
    {
        lat: 49.01,
        lng: 11.77,
    },
    {
        lat: 49.04,
        lng: 11.8,
    },
    {
        lat: 49.045,
        lng: 11.86,
    },
    {
        lat: 49.03,
        lng: 11.905,
    },
    {
        lat: 48.975,
        lng: 11.95,
    },
    {
        lat: 48.985,
        lng: 11.96,
    },
    {
        lat: 48.985,
        lng: 12.03,
    },
    {
        lat: 48.965,
        lng: 12.055,
    },
    {
        lat: 48.95,
        lng: 12.1,
    },
    {
        lat: 48.94,
        lng: 12.1,
    },
    {
        lat: 48.94,
        lng: 12.11,
    },
    {
        lat: 48.925,
        lng: 12.115,
    },
    {
        lat: 48.91,
        lng: 12.14,
    },
    {
        lat: 48.9,
        lng: 12.14,
    },
    {
        lat: 48.885,
        lng: 12.155,
    },
    {
        lat: 48.855,
        lng: 12.15,
    },
    {
        lat: 48.845,
        lng: 12.145,
    },
    {
        lat: 48.84,
        lng: 12.13,
    },
    {
        lat: 48.82,
        lng: 12.125,
    },
    {
        lat: 48.8,
        lng: 12.13,
    },
    {
        lat: 48.8,
        lng: 12.14,
    },
    {
        lat: 48.82,
        lng: 12.165,
    },
    {
        lat: 48.83,
        lng: 12.21,
    },
    {
        lat: 48.85,
        lng: 12.215,
    },
    {
        lat: 48.88,
        lng: 12.255,
    },
    {
        lat: 48.88,
        lng: 12.275,
    },
    {
        lat: 48.87,
        lng: 12.285,
    },
    {
        lat: 48.885,
        lng: 12.32,
    },
    {
        lat: 48.88,
        lng: 12.35,
    },
    {
        lat: 48.865,
        lng: 12.37,
    },
    {
        lat: 48.875,
        lng: 12.375,
    },
    {
        lat: 48.885,
        lng: 12.4,
    },
    {
        lat: 48.915,
        lng: 12.41,
    },
    {
        lat: 48.92,
        lng: 12.425,
    },
    {
        lat: 48.985,
        lng: 12.42,
    },
    {
        lat: 49,
        lng: 12.43,
    },
    {
        lat: 49.005,
        lng: 12.445,
    },
    {
        lat: 49,
        lng: 12.465,
    },
    {
        lat: 49.035,
        lng: 12.45,
    },
    {
        lat: 49.05,
        lng: 12.455,
    },
    {
        lat: 49.08,
        lng: 12.485,
    },
    {
        lat: 49.08,
        lng: 12.515,
    },
    {
        lat: 49.09,
        lng: 12.515,
    },
    {
        lat: 49.1,
        lng: 12.54,
    },
    {
        lat: 49.11,
        lng: 12.545,
    },
    {
        lat: 49.13,
        lng: 12.645,
    },
    {
        lat: 49.125,
        lng: 12.7,
    },
    {
        lat: 49.14,
        lng: 12.725,
    },
    {
        lat: 49.135,
        lng: 12.75,
    },
    {
        lat: 49.155,
        lng: 12.775,
    },
    {
        lat: 49.155,
        lng: 12.795,
    },
    {
        lat: 49.145,
        lng: 12.805,
    },
    {
        lat: 49.155,
        lng: 12.83,
    },
    {
        lat: 49.15,
        lng: 12.855,
    },
    {
        lat: 49.155,
        lng: 12.895,
    },
    {
        lat: 49.17,
        lng: 12.91,
    },
    {
        lat: 49.165,
        lng: 12.94,
    },
    {
        lat: 49.185,
        lng: 12.96,
    },
    {
        lat: 49.175,
        lng: 13.055,
    },
    {
        lat: 49.16,
        lng: 13.08,
    },
    {
        lat: 49.14,
        lng: 13.09,
    },
    {
        lat: 49.135,
        lng: 13.115,
    },
    {
        lat: 49.15,
        lng: 13.125,
    },
    {
        lat: 49.155,
        lng: 13.14,
    },
    {
        lat: 49.175,
        lng: 13.145,
    },
    {
        lat: 49.195,
        lng: 13.165,
    },
    {
        lat: 49.195,
        lng: 13.175,
    },
    {
        lat: 49.18,
        lng: 13.195,
    },
    {
        lat: 49.15,
        lng: 13.195,
    },
    {
        lat: 49.14,
        lng: 13.21,
    },
    {
        lat: 49.135,
        lng: 13.225,
    },
    {
        lat: 49.14,
        lng: 13.295,
    },
    {
        lat: 49.065,
        lng: 13.415,
    },
    {
        lat: 48.995,
        lng: 13.43,
    },
    {
        lat: 48.985,
        lng: 13.445,
    },
    {
        lat: 48.985,
        lng: 13.46,
    },
    {
        lat: 48.97,
        lng: 13.485,
    },
    {
        lat: 48.99,
        lng: 13.5,
    },
    {
        lat: 48.995,
        lng: 13.525,
    },
    {
        lat: 48.99,
        lng: 13.59,
    },
    {
        lat: 48.975,
        lng: 13.61,
    },
    {
        lat: 48.965,
        lng: 13.61,
    },
    {
        lat: 48.965,
        lng: 13.645,
    },
    {
        lat: 48.93,
        lng: 13.655,
    },
    {
        lat: 48.9,
        lng: 13.685,
    },
    {
        lat: 48.905,
        lng: 13.72,
    },
    {
        lat: 48.9,
        lng: 13.755,
    },
    {
        lat: 48.855,
        lng: 13.775,
    },
    {
        lat: 48.845,
        lng: 13.81,
    },
    {
        lat: 48.825,
        lng: 13.815,
    },
    {
        lat: 48.805,
        lng: 13.835,
    },
    {
        lat: 48.79,
        lng: 13.835,
    },
    {
        lat: 48.79,
        lng: 13.85,
    },
    {
        lat: 48.78,
        lng: 13.86,
    },
    {
        lat: 48.76,
        lng: 13.86,
    },
    {
        lat: 48.745,
        lng: 13.85,
    },
    {
        lat: 48.745,
        lng: 13.84,
    },
    {
        lat: 48.725,
        lng: 13.835,
    },
    {
        lat: 48.715,
        lng: 13.855,
    },
    {
        lat: 48.685,
        lng: 13.855,
    },
    {
        lat: 48.675,
        lng: 13.84,
    },
    {
        lat: 48.61,
        lng: 13.845,
    },
    {
        lat: 48.595,
        lng: 13.825,
    },
    {
        lat: 48.56,
        lng: 13.82,
    },
    {
        lat: 48.535,
        lng: 13.77,
    },
    {
        lat: 48.525,
        lng: 13.77,
    },
    {
        lat: 48.495,
        lng: 13.74,
    },
    {
        lat: 48.495,
        lng: 13.705,
    },
    {
        lat: 48.51,
        lng: 13.685,
    },
    {
        lat: 48.52,
        lng: 13.645,
    },
    {
        lat: 48.535,
        lng: 13.64,
    },
    {
        lat: 48.535,
        lng: 13.615,
    },
    {
        lat: 48.545,
        lng: 13.605,
    },
    {
        lat: 48.54,
        lng: 13.565,
    },
    {
        lat: 48.565,
        lng: 13.52,
    },
    {
        lat: 48.545,
        lng: 13.5,
    },
    {
        lat: 48.535,
        lng: 13.47,
    },
    {
        lat: 48.51,
        lng: 13.48,
    },
    {
        lat: 48.46,
        lng: 13.45,
    },
    {
        lat: 48.445,
        lng: 13.46,
    },
    {
        lat: 48.425,
        lng: 13.46,
    },
    {
        lat: 48.4,
        lng: 13.44,
    },
    {
        lat: 48.37,
        lng: 13.435,
    },
    {
        lat: 48.35,
        lng: 13.415,
    },
    {
        lat: 48.34,
        lng: 13.38,
    },
    {
        lat: 48.3,
        lng: 13.335,
    },
    {
        lat: 48.3,
        lng: 13.32,
    },
    {
        lat: 48.275,
        lng: 13.27,
    },
    {
        lat: 48.275,
        lng: 13.175,
    },
    {
        lat: 48.26,
        lng: 13.145,
    },
    {
        lat: 48.26,
        lng: 13.085,
    },
    {
        lat: 48.245,
        lng: 13.065,
    },
    {
        lat: 48.24,
        lng: 13.025,
    },
    {
        lat: 48.2,
        lng: 12.985,
    },
    {
        lat: 48.185,
        lng: 12.95,
    },
    {
        lat: 48.19,
        lng: 12.92,
    },
    {
        lat: 48.205,
        lng: 12.895,
    },
    {
        lat: 48.23,
        lng: 12.87,
    },
    {
        lat: 48.245,
        lng: 12.875,
    },
    {
        lat: 48.26,
        lng: 12.84,
    },
    {
        lat: 48.28,
        lng: 12.83,
    },
    {
        lat: 48.28,
        lng: 12.815,
    },
    {
        lat: 48.305,
        lng: 12.79,
    },
    {
        lat: 48.3,
        lng: 12.73,
    },
    {
        lat: 48.31,
        lng: 12.72,
    },
    {
        lat: 48.31,
        lng: 12.7,
    },
    {
        lat: 48.32,
        lng: 12.685,
    },
    {
        lat: 48.31,
        lng: 12.67,
    },
    {
        lat: 48.325,
        lng: 12.625,
    },
    {
        lat: 48.32,
        lng: 12.61,
    },
    {
        lat: 48.325,
        lng: 12.6,
    },
    {
        lat: 48.355,
        lng: 12.585,
    },
    {
        lat: 48.365,
        lng: 12.56,
    },
    {
        lat: 48.38,
        lng: 12.555,
    },
    {
        lat: 48.38,
        lng: 12.535,
    },
    {
        lat: 48.405,
        lng: 12.505,
    },
    {
        lat: 48.395,
        lng: 12.46,
    },
    {
        lat: 48.38,
        lng: 12.46,
    },
    {
        lat: 48.37,
        lng: 12.445,
    },
    {
        lat: 48.355,
        lng: 12.44,
    },
    {
        lat: 48.355,
        lng: 12.43,
    },
    {
        lat: 48.34,
        lng: 12.42,
    },
    {
        lat: 48.34,
        lng: 12.4,
    },
    {
        lat: 48.31,
        lng: 12.365,
    },
    {
        lat: 48.31,
        lng: 12.34,
    },
    {
        lat: 48.295,
        lng: 12.315,
    },
    {
        lat: 48.305,
        lng: 12.27,
    },
    {
        lat: 48.3,
        lng: 12.245,
    },
    {
        lat: 48.31,
        lng: 12.225,
    },
    {
        lat: 48.33,
        lng: 12.215,
    },
    {
        lat: 48.345,
        lng: 12.195,
    },
    {
        lat: 48.345,
        lng: 12.185,
    },
    {
        lat: 48.36,
        lng: 12.17,
    },
    {
        lat: 48.375,
        lng: 12.17,
    },
    {
        lat: 48.4,
        lng: 12.145,
    },
    {
        lat: 48.395,
        lng: 12.125,
    },
    {
        lat: 48.405,
        lng: 12.11,
    },
    {
        lat: 48.4,
        lng: 12.065,
    },
    {
        lat: 48.405,
        lng: 12.055,
    },
    {
        lat: 48.395,
        lng: 12.045,
    },
    {
        lat: 48.4,
        lng: 12.005,
    },
    {
        lat: 48.43,
        lng: 11.995,
    },
    {
        lat: 48.435,
        lng: 11.975,
    },
    {
        lat: 48.445,
        lng: 11.97,
    },
    {
        lat: 48.47,
        lng: 11.98,
    },
    {
        lat: 48.48,
        lng: 11.95,
    },
    {
        lat: 48.5,
        lng: 11.935,
    },
    {
        lat: 48.515,
        lng: 11.945,
    },
    {
        lat: 48.555,
        lng: 11.94,
    },
    {
        lat: 48.565,
        lng: 11.905,
    },
    {
        lat: 48.56,
        lng: 11.855,
    },
    {
        lat: 48.575,
        lng: 11.84,
    },
    {
        lat: 48.58,
        lng: 11.8,
    },
    {
        lat: 48.59,
        lng: 11.795,
    },
    {
        lat: 48.58,
        lng: 11.785,
    },
    {
        lat: 48.585,
        lng: 11.725,
    },
    {
        lat: 48.6,
        lng: 11.685,
    },
    {
        lat: 48.625,
        lng: 11.67,
    },
];
